import Vue from 'vue';
import App from './views/App.vue';
import Login from './views/Login.vue';
import router from './router';
import store from './store';
import api from './api';
import AppContent from './components/AppContent';
import AccountDateChoose from './components/AccountDateChoose';
import SubMenu from './components/common/sub-menu';
import Chart from './views/app/chart/echarts';

import './js/config/dict';
import './js/common/filters';

// if (process.env.NODE_ENV !== 'development') {
// 	require('./reporter');
// }

require('font-awesome/css/font-awesome.css');
require('./styles/app.less');

Vue.use(HeyUI);
Vue.prototype.$api = api;

Vue.component("app-content", AppContent);
Vue.component("account-date-choose", AccountDateChoose);
Vue.component('sub-menu', SubMenu);
Vue.component('Chart', Chart);

Vue.config.productionTip = false;

const VueConfig = {
	router,
	store,
};

// 分发名为 'init' 的 action 到 Vuex store，用于初始化应用所需的状态
// 该 action 通常会进行一些异步操作，如获取用户信息、加载配置等
store.dispatch("init").then(() => {
	// 当 'init' action 成功执行后，实例化界面
	// 使用 Object.assign 方法将 VueConfig 对象和一个包含 render 函数的对象合并
	// render 函数用于创建根组件 App 的虚拟 DOM
	new Vue(Object.assign(VueConfig, {
		render: h => h(App)
	})).$mount('#app'); // 将 Vue 实例挂载到 id 为 'app' 的 DOM 元素上
}).catch(() => {
	// 当 'init' action 执行失败时，实例化登录界面
	// 同样使用 Object.assign 方法合并对象，此时 render 函数创建 Login 组件的虚拟 DOM
	new Vue(Object.assign(VueConfig, {
		render: h => h(Login)
	})).$mount('#app'); // 将 Vue 实例挂载到 id 为 'app' 的 DOM 元素上
});

